import {
  tasksListTablBodyTranslation,
  TasksListTableBodyTranslation,
} from '@/assets/locales/views/tasks/list/tasksListView.translation.pl.ts';

export type DashboardViewTranslation = {
  announcements: {
    collapse: string;
    empty: string;
    emptyShort: string;
    expand: string;
    new: string;
    openChat: string;
    placeholder: string;
    readBy: string;
    send: string;
    sendHint: string;
    title: string;
    tooLong: string;
    unread: {
      few: string;
      many: string;
      one: string;
    };
  };
  cars: {
    cars: string;
    collapse: string;
    critical: string;
    expand: string;
    missing: string;
    missingHint: string;
    open: string;
    title: string;
  };
  emails: {
    noThreadsInFolder: string;
    title: string;
  };
  expiry: {
    actions: {
      dishes: string;
      sets: string;
    };
    collapse: string;
    expand: string;
    missingDishes: string;
    summary: string;
    title: string;
  };
  processes: {
    body: {
      createdAt: string;
      customer: string;
      deadline: string;
      name: string;
      status: string;
      tasks: string;
    };
    empty: string;
    filters: {
      all: string;
      dueToday: string;
      overdue: string;
      upcoming: string;
    };
    info: {
      deadline: string;
      icons: string;
      scope: string;
      sorting: string;
      title: string;
    };
  };
  tasks: {
    body: TasksListTableBodyTranslation;
    title: string;
  };
  topBar: {
    contacts: {
      button: {
        add: string;
      };
    };
    tasks: {
      button: {
        add: string;
      };
    };
  };
};

export const dashboardViewTranslation: DashboardViewTranslation = {
  announcements: {
    collapse: 'Zwiń ogłoszenia',
    empty: 'Nie ma jeszcze ogłoszeń. Napisz pierwsze — trafi do wszystkich aktywnych użytkowników.',
    emptyShort: 'Brak ogłoszeń — rozwiń, żeby napisać do wszystkich',
    expand: 'Rozwiń ogłoszenia',
    new: 'Nowe',
    openChat: 'Wszystkie ogłoszenia',
    placeholder:
      'Napisz do wszystkich, np. „Dziś 18:00–19:00 aplikacja będzie niedostępna — wdrożenie.”',
    readBy: 'Przeczytane przez {{count}} z {{total}}',
    send: 'Wyślij do wszystkich',
    sendHint: 'Ctrl + Enter wysyła',
    title: 'Ogłoszenia',
    tooLong: 'Ogłoszenie jest za długie — skróć je o {{count}} zn.',
    unread: {
      few: '{{count}} nowe',
      many: '{{count}} nowych',
      one: '1 nowe',
    },
  },
  cars: {
    cars: 'Auta: {{count}}',
    collapse: 'Zwiń',
    critical: 'Pilne: {{count}}',
    expand: 'Pokaż szczegóły',
    missing: 'Do uzupełnienia: {{count}}',
    missingHint:
      'Terminy bez daty: {{count}} — uzupełnij je albo oznacz „Nie dotyczy” w szczegółach auta.',
    open: 'Przejdź do aut',
    title: 'Auta wymagają uwagi',
  },
  emails: {
    noThreadsInFolder: 'Brak nieprzeczytanych wiadomości',
    title: 'Ostatnie nieprzeczytane maile',
  },
  expiry: {
    actions: {
      dishes: 'Dania',
      sets: 'Zestawy grup',
    },
    collapse: 'Zwiń',
    expand: 'Pokaż szczegóły',
    missingDishes:
      '{{count}} dań nie ma dziś żadnego ważnego cennika — te wyceniają się przelicznikiem.',
    summary: '{{parts}} traci ważność w ciągu {{days}} dni.',
    title: 'Cenniki wymagają uwagi',
  },
  processes: {
    body: {
      createdAt: 'Utworzony',
      customer: 'Klient',
      deadline: 'Termin',
      name: 'Nazwa',
      status: 'Status',
      tasks: 'Zadania',
    },
    empty: 'Nic nie czeka — wszystkie Twoje procesy są na bieżąco.',
    filters: {
      all: 'Wszystkie',
      dueToday: 'Na dziś',
      overdue: 'Przeterminowane',
      upcoming: 'Nadchodzące ({{days}} dni)',
    },
    info: {
      deadline:
        'Kolumna „Termin” to termin najpilniejszego z tych zadań. Termin po czasie jest czerwony, a wiersz ma czerwony pasek z lewej strony; po najechaniu na datę widać, ile dni minęło. Strzałka przy nazwie rozwija podgląd procesu bez wchodzenia do środka.',
      icons:
        'Ikony w kolumnie „Zadania” pokazują rodzaje zadań wiszących pod procesem, a liczba obok — ile ich jest. Zadania założone przed wprowadzeniem rodzajów mają ikonę ogólną.',
      scope:
        'Kafelki po lewej zawężają widok po terminie zadania, te za kreską — po rodzaju zadania; rodzaje można łączyć. Liczby pokazują, ile procesów czeka w każdym z filtrów, zawsze z całego zbioru, niezależnie od tego, co masz włączone. Kafelek „Wszystkie” zdejmuje oba zawężenia naraz.',
      sorting:
        'Domyślnie na górze jest najstarszy nieobsłużony termin. Każdy nagłówek kolumny można kliknąć, żeby przesortować — również po liczbie zadań.',
      title: 'Twoje procesy z otwartymi zadaniami',
    },
  },
  tasks: {
    body: tasksListTablBodyTranslation,
    title: 'Bieżące zadania',
  },
  topBar: {
    contacts: {
      button: {
        add: 'Dodaj kontakt',
      },
    },
    tasks: {
      button: {
        add: 'Dodaj zadanie',
      },
    },
  },
};
